import { AutoComplete, Listbox } from "../../styles/global.style";
import { FormControl, InputAdornment, InputLabel } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { InputCustom } from "../../styles/styledComponents";
import { Loading } from "..";
import { useDebounce } from "../../hooks";
import { usePetColors } from "../../services/pet-colors/pet-colors.service";

interface IAutocompleteColorSearchProps {
  id?: string;
  text: string;
  onSelect: (breed: IOptionGeneric) => void;
  onChange: (text: string) => void;
  className?: string;
}

const AutocompleteColorSearch = ({
  id,
  text,
  onSelect,
  onChange,
  className,
}: IAutocompleteColorSearchProps) => {
  const [showPrediction, setShowPrediction] = useState(false);
  const [search, setSearch] = useState<string>("");
  const debouncedValue = useDebounce<string>(search);
  const { searchPetColors, loading, colors } = usePetColors();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
    setSearch(event.target.value);
  };

  const handleSelectItem = (breed: any) => {
    setSearch(breed.label);
    onSelect(breed);
    setShowPrediction(false);
  };

  useEffect(() => {
    setSearch(text);
  }, [text]);

  useEffect(() => {
    searchPetColors(debouncedValue);
  }, [debouncedValue]);

  return (
    <AutoComplete>
      <FormControl fullWidth={true}>
        <InputLabel htmlFor={id} className={`${className}`} >Color (optional)</InputLabel>
        <InputCustom
          id={id}
          type="text"
          placeholder="Enter color"
          value={search}
          onChange={handleChange}
          onFocus={() => setShowPrediction(true)}
          InputProps={{
            endAdornment: <InputAdornment position="end">
              {loading && <Loading size={26} />}
            </InputAdornment>,
          }}
          autoComplete="off"
        />

        {showPrediction && colors?.length > 0 ? (
          <Listbox>
            {colors.map((color) => (
              <li key={color.value} onClick={() => handleSelectItem(color)}>{color.label}</li>
            ))}
          </Listbox>
        ) : null}
      </FormControl>
    </AutoComplete>
  );
};

export default AutocompleteColorSearch;
